import {cloneDeep} from 'lodash';
import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Store} from '@ngxs/store';
import {ClinicActions, ClinicState, IClinic} from '../../models/clinic';
import {ActivatedRoute, Router} from '@angular/router';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {firstValueFrom, Observable} from 'rxjs';
import {Loader} from '../../models/loader/loader.redux';

@Component({
  selector: 'app-user-register-privacy',
  templateUrl: './user-register-privacy.component.html',
  styleUrls: ['./user-register-privacy.component.scss']
})
export class UserRegisterPrivacyComponent implements OnInit {

  clinic$: Observable<IClinic> = this.store.select<any>(ClinicState.getClinicSelected);
  @Output() alreadyAccepted: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private store: Store,
    private router: Router,
    private utilityService: UtilitiesService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initValuesHttp();
  }

  async initValuesHttp(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true, 'Cargando términos y condiciones'))));
    const clinicId = this.utilityService.getAllParams(this.activatedRoute).clinicId;
    if (clinicId) {
      await firstValueFrom((this.store.dispatch(new ClinicActions.GetClinicBasicInformationAction(clinicId))));
      await firstValueFrom((this.store.dispatch(new ClinicActions.AlreadyAcceptTerms(clinicId))));
      const alreadyAcceptTerms = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicState.getAlreadyAcceptTerms))));
      if (alreadyAcceptTerms?.acceptedTerms) {
        this.alreadyAccepted.emit(true);
      }
    }
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

}
